import type { ReactNode } from 'react'
import { QueryClientProvider } from '@tanstack/react-query'
import { trpcClient, type AppRouterContext } from '@/trpc/context.ts'
import { TRPCProvider } from '@/trpc/react.ts'

export function TrpcProvider({ children, context }: { children: ReactNode; context: AppRouterContext }) {
  return (
    <QueryClientProvider client={context.queryClient}>
      <TRPCProvider trpcClient={trpcClient} queryClient={context.queryClient}>
        {children}
      </TRPCProvider>
    </QueryClientProvider>
  )
}
